module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Telling Tales - Out of School")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#the-colouring-pencil-dream"
    }
  }, [_vm._v("The Colouring Pencil Dream")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#the-american-way"
    }
  }, [_vm._v("The American Way")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#growing-a-school"
    }
  }, [_vm._v("Growing a School")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-school-with-the-birthday-box",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The School With The Birthday Box")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-l-plate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The L-Plate")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#snail-club",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snail Club")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#sorrymy-mistake",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sorry—My Mistake!")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#how-to-hook-them",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Hook Them")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#surviving-friday-afternoons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Surviving Friday Afternoons")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#what-on-earth-just-happened",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What on Earth Just Happened?")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#let-me-tell-you-about-mick",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let Me Tell You about Mick")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#dannys-story",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Danny’s Story")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#davids-story",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David’s Story")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#kerry-annes-story",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kerry-Anne’s Story")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#mrs-minnss-story",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mrs Minns’s Story")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#hearing-things",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hearing Things")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#facing-the-music",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Facing the Music")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#the-inspectors-visit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inspector’s Visit")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-punishment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Punishment")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#not-july-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not July 10!")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#not-what-i-envisaged",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not What I Envisaged")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#accompanying-us-everywhere",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Accompanying Us Everywhere!")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#so-far-so-good",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So Far, So Good!")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#just-what-i-needed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just What I Needed!")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#i-can-relax-now",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Can Relax Now…")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#not-such-a-little-thing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Such a Little Thing!")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#poor-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poor Me!")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#no-dramas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Dramas!")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#the-final-gift",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Final Gift")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#once-a-teacher-always-a-teacher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Once a Teacher, Always a Teacher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0